// src/pages/Admin/AdminPlaceholder.jsx
// Placeholder para secciones aún no desarrolladas
import React from 'react';

const styles = {
  minHeight: '60vh', display: 'flex', flexDirection: 'column',
  alignItems: 'center', justifyContent: 'center', gap: '1rem',
  color: '#5a6a63', textAlign: 'center',
};
const iconStyle = {
  width: 56, height: 56, borderRadius: 16,
  background: '#d4f4e8', display: 'flex', alignItems: 'center', justifyContent: 'center',
  fontSize: '1.6rem',
};

export default function AdminPlaceholder({ titulo = 'Próximamente', subtitulo = 'Esta sección está en desarrollo.' }) {
  return (
    <div style={styles}>
      <div style={iconStyle}>🚧</div>
      <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: '2rem', color: '#111614' }}>{titulo}</h2>
      <p style={{ fontSize: '.92rem', maxWidth: 360 }}>{subtitulo}</p>
    </div>
  );
}